module.exports = __webpack_public_path__ + "static/img/弹窗-污染源.55a1590.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/comp/弹窗-污染源.png
// module id = fHko
// module chunks = 3